import type { DecoratedAggregatedOrderView } from '@/types/api/aggregated/order'

import { getCustodianDisplayName } from '@/trading/helpers/custodians'
import { PLACEHOLDER } from '@/utils/presentation/formatting'

import { getAccountRequestsFromAllocation } from './get-account-requests-from-allocation'
import { getLatestAllocationUpdate } from './get-latest-allocation-update'
import { getUniqueCustodianIdsFromAccountRequests } from './get-unique-custodian-ids'

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function getCustodianName(
  order: DecoratedAggregatedOrderView | null,
): string {
  if (!order) return PLACEHOLDER

  const latestAllocation = getLatestAllocationUpdate(order.trading_events)
  const accountRequests = latestAllocation
    ? getAccountRequestsFromAllocation(latestAllocation)
    : []
  const uniqueCustodianIds =
    getUniqueCustodianIdsFromAccountRequests(accountRequests)

  if (uniqueCustodianIds.length > 1) return 'Multiple'
  if (uniqueCustodianIds.length === 1) {
    // biome-ignore lint/style/noNonNullAssertion: suppress noUncheckedIndexedAccess
    return getCustodianDisplayName(uniqueCustodianIds[0]!)
  }

  // Single orders (no allocations) carry the custodian on the order-level
  // account_configuration rather than per-allocation account_requests.
  const singleOrderCustodianId = order.account_configuration?.custodian_id
  if (singleOrderCustodianId) {
    return getCustodianDisplayName(singleOrderCustodianId)
  }

  return PLACEHOLDER
}
